import React, { Component } from 'react'
import Box from './Box';
import {IconButton} from '@material-ui/core';
import { ArrowLeftRounded, ArrowRightRounded } from '@material-ui/icons'
export class Container extends Component {
constructor(props){
    super(props);
    this.state={
        i:0,
    }
}

 

    render() {

        const {i} =this.state;
        const {title, data} =this.props;
    
        return (
            <div className="container">
            <p className="container-title">{title}</p>

            {i!=0&&<IconButton onClick={()=>{this.setState({i:i-1})}} className="left">
               <ArrowLeftRounded />
           </IconButton>}
           {i==0&&<IconButton disabled className="left">
               <ArrowLeftRounded />
           </IconButton>}

           {(i+6)!=20&&<IconButton onClick={()=>{this.setState({i:i+1})}} className="right">
               <ArrowRightRounded />
           </IconButton>}
           {(i+6)==20&&<IconButton disabled className="right">
               <ArrowRightRounded />
           </IconButton>}
            <div className="box">
           
                <Box 
                  data={data[i]} dispatch={this.props.dispatch} className="boxs"
                />
                <Box
                    data={data[i+1]} dispatch={this.props.dispatch} className="boxs"
                />
                <Box
                   data={data[i+2]} dispatch={this.props.dispatch} className="boxs"
                />
                <div className="toshow">
                <Box
                    data={data[i+3]} dispatch={this.props.dispatch} className="boxs"
                />
                <Box
                    data={data[i+4]} dispatch={this.props.dispatch} className="boxs"
                />
                <Box
                    data={data[i+5]} dispatch={this.props.dispatch} className="boxs"
                />
                </div>
            </div>
            
            </div>
        )
    }
}

export default Container
